import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getCandidateResultWithFilterPage as asyncGetCandidateResultWithFilter,
  getCandidateResultWithId   as asyncGetCandidateResultByID,
  getAllCandiateWithFilter as asyncGetAllCandidateresult
} from "../../helpers/apis";
import { showToast } from "../toast/reducer";

// Fetch candidate results with filter
export const getCandidateResultWithFilterPage = createAsyncThunk(
  "getCandidateResultWithFilter",
  async (req, thunkAPI) => {
    try {
      // Send pagination and filter params to the API request
      // const { currentPage = 1, perPage = 20, ...filters } = req; // Ensure pagination is included
      const response = await asyncGetCandidateResultWithFilter(req);
      console.log(req);
      console.log("Fetched candidate results thunk:", response);
      return response;
    } catch (error) {
      thunkAPI.dispatch(
        showToast({ type: "error", msg: error?.msg || "Error fetching candidate results" })
      );
      throw error;
    }
  }
);

// Fetch single candidate result by ID
export const getCandidateResultWithId = createAsyncThunk(
  "getCandidateResultWithId",
  async (candidateResultId, thunkAPI) => {
    try {
      const response = await asyncGetCandidateResultByID(candidateResultId);
      console.log("Fetched candidate result by ID:", response);
      return response;
    } catch (error) {
      thunkAPI.dispatch(
        showToast({ type: "error", msg: error?.msg || "Error fetching candidate result by ID" })
      );
      throw error;
    }
  }
);




export const getAllCandiateWithFilter = createAsyncThunk(
  "category/getCategoryWithFilter",
  async (req, thunkAPI) => {
    try {
      const response = await asyncGetAllCandidateresult(req);
      console.log("Fetched candidate result response:", response); // For debugging
      return response;
    } catch (error) {
      const errorMessage = error?.msg || error.message || "Error candidate result categories";
      thunkAPI.dispatch(showToast({ type: "error", msg: errorMessage }));
      throw error;
    }
  }
);